"use client";

import * as React from "react";

export default function TransferInProgressSimulation() {
  const [day, setDay] = React.useState(1);
  const [status, setStatus] = React.useState("Processing...");

  React.useEffect(() => {
    const interval = setInterval(() => {
      setDay((prev) => {
        if (prev === 3) {
          setStatus("Weekend delay...");
          // After showing the weekend message for 2.5 seconds, reset
          setTimeout(() => {
            setDay(1);
            setStatus("Processing...");
          }, 2500);
          return prev;
        } else {
          return prev + 1;
        }
      });
    }, 2500); // 2.5 seconds between each "day"
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        backgroundColor: "#0f0f0f",
        color: "#f5f5f5",
        borderRadius: "16px",
        padding: "32px",
        width: "100%",
        maxWidth: "420px",
        margin: "0 auto",
        fontFamily: "Inter, sans-serif",
        boxShadow: "0 0 16px rgba(0,0,0,0.3)",
      }}
    >
      <h2 style={{ fontSize: "20px", fontWeight: 600, marginBottom: "8px" }}>
        Transfer in Progress
      </h2>

      <p
        style={{
          fontSize: "14px",
          color: "#bdbdbd",
          marginBottom: "24px",
        }}
      >
        Your transfer is being processed. Please wait...
      </p>

      {/* Progress Bar */}
      <div
        style={{
          backgroundColor: "#2a2a2a",
          borderRadius: "8px",
          height: "8px",
          marginBottom: "24px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: "20%",
            height: "100%",
            backgroundColor: "#444",
            transition: "width 0.5s ease",
          }}
        ></div>
      </div>

      {/* Day and Status */}
      <div style={{ textAlign: "center" }}>
        <p style={{ fontSize: "14px", color: "#f5f5f5", margin: 0 }}>
          <strong>Day {day}</strong>
        </p>
        <p style={{ fontSize: "12px", color: "#999", margin: "4px 0" }}>{status}</p>

        <div style={{ marginTop: "12px", fontSize: "12px", color: "#ffb347", minHeight: "20px" }}>
          {day === 3 && (
            <>
              <span role="img" aria-label="weekend">
                🏖️
              </span>{" "}
              It&apos;s the weekend. Please check back later.
            </>
          )}
        </div>
      </div>
    </div>
  );
}
